import React, { useState } from 'react';
import './LandingPage.css';
import screen1img from '../img/screen1img-removebg-preview.png';

const LandingPage = ({ onStart }) => {
  const [consent, setConsent] = useState(false);

  return (
    <div className="landing-container">
      <div className="landing-content">
        <h1>Let's get started!</h1>
        <p className="subtitle">
        Capture your ID and a selfie to verify your age securely and instantly. Our tool ensures fast, accurate, and privacy-conscious verification
        </p>
        <img 
  src={screen1img} 
  alt="Age verification illustration" 
  className="illustration-img"
/>
        <div className="consent-box">
          <label>
            <input
              type="checkbox"
              checked={consent}
              onChange={() => setConsent(!consent)}
            />
            <span>
              I consent to the processing of my personal data, including biometric data, as
              described in the{' '}
              <a href="https://myearth.id/privacy-policy" target="_blank" rel="noopener noreferrer">
                Privacy Notice
              </a>
            </span>
          </label>
        </div>

        <button
          className="start-btn"
          disabled={!consent}
          onClick={onStart}
        >
          Start Verification
        </button>
      </div>
    </div>
  );
};

export default LandingPage;
